import { getRequest, postRequest } from 'config/Axios/baseConfig';
import { notesInterface } from 'Interfaces/FDPInterfaces/tmsInterfaces';
import {
  activeNDCInterface,
  bulkNDCsInterface,
  invoiceSalesSummary,
  noteEditResponse,
  unconstrainedForecastInterface,
  unconstrainedForecastInterfaceView,
  unconstrainedForecastStatusInterface,
  unconstrinedForecastViewInterface,
} from 'Interfaces/FDPInterfaces/unconstrainedForecast';
import {
  bulkEditDataInterface,
  filterPayloadInterface,
} from 'Interfaces/FDPInterfaces/unconstrainedForecastBulkEdit';
import {
  UploadForecastCreatePayload,
  UploadForecastPreviewResponse,
} from 'Interfaces/FDPInterfaces/unconstrainedForecastUpload';

export const unconstrainedForecastService = {
  getWholeSalesDemandForecast: (gfc: number): Promise<unconstrinedForecastViewInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<unconstrinedForecastViewInterface>(
          `fdp/get_wholesaler_demand_forecast/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log(
          'in unconstrainedForecastservices > getWholeSalesDemandForecast, Err===',
          error
        );
        reject(error);
      }
    });
  },

  getUnconstrainedForecastStatus: (
    gfc: number
  ): Promise<unconstrainedForecastStatusInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<unconstrainedForecastStatusInterface[]>(
          `fdp/get_unconstrained_status/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getUnconstrainedForecastStatus, Err===', error);
        reject(error);
      }
    });
  },

  getUnconstrainedForecastProgress: (): Promise<{ percentage: number }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<{ percentage: number }>(
          `fdp/get_unconstrained_forecast_progress`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getUnconstrainedForecastProgress, Err===', error);
        reject(error);
      }
    });
  },

  getDirectUnconstrainedForecastProgress: (): Promise<{
    percentage: number;
  }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<{ percentage: number }>(
          `fdp/get_direct_unconstrained_forecast_progress`
        );
        resolve(data);
      } catch (error) {
        console.log('in service > getDirectUnconstrainedForecastProgress, Err===', error);
        reject(error);
      }
    });
  },

  getSalesSummaryDetails: (gfc: number): Promise<invoiceSalesSummary[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<invoiceSalesSummary[]>(`fdp/get_invoice_summary/${gfc}`);
        resolve(data);
      } catch (error) {
        console.log('getSalesSummaryDetails=> ', error);
        reject(error);
      }
    });
  },

  getActiveNDCByConcept: (gfc: number): Promise<activeNDCInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<activeNDCInterface[]>(`fdp/get_active_ndc/${gfc}`);
        resolve(data);
      } catch (error) {
        console.log('in unconstrainedForecastservices > getActiveNDCByConcept, Err===', error);
        reject(error);
      }
    });
  },

  getUnconstrainedForecast: (
    gfc: string,
    planning_period: string
  ): Promise<unconstrainedForecastInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<unconstrainedForecastInterface>(
          `fdp/get_unconstrained_forecast/${planning_period}/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in getUnconstrainedForecast > getActiveNDCByConcept, Err===', error);
        reject(error);
      }
    });
  },

  getUnconstrainedForecastView: (
    gfc: string,
    planning_period: string
  ): Promise<unconstrainedForecastInterfaceView> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<unconstrainedForecastInterfaceView>(
          `fdp/get_unconstrained_forecast_view/${planning_period}/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in getUnconstrainedForecast > getActiveNDCByConcept, Err===', error);
        reject(error);
      }
    });
  },

  getBulkNDCList: (): Promise<bulkNDCsInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<bulkNDCsInterface>(`fdp/get_unconstrained_status_all`);
        resolve(data);
      } catch (error) {
        console.log('in getUnconstrainedForecast > getBulkNDCList, Err===', error);
        reject(error);
      }
    });
  },

  getUnconstrainedForecastPlanningPeriods: (gfc: number): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<string[]>(`fdp/get_unconstrained_planning_period/${gfc}`);
        resolve(data);
      } catch (error) {
        console.log(
          'in getUnconstrainedForecast > getUnconstrainedForecastPlanningPeriods, Err===',
          error
        );
        reject(error);
      }
    });
  },

  saveUnconstrainedForecast: (
    payload: {
      NDC11: string;
      PlanningPeriod: string;
      ForecastPeriod: string;
      StratCode: string;
      WholesalerDemandForecast: number;
      Adjustment: number;
      UnconstrainedForecast: number;
      Notes: string;
    }[]
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `fdp/unconstrained_forecast_save`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > saveUnconstrainedForecast, Err===', error);
        reject(error);
      }
    });
  },

  bulkUpdateNDCs: (payload: {
    selling_category: 'direct' | 'indirect' | 'all';
  }): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `fdp/bulk_update_unconstrained_forecast`,
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getNDC11Note: (
    ndc11: string,
    planning_type: string,
    signal: AbortController['signal'] | null = null
  ): Promise<notesInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<notesInterface[]>(
            `fdp/get_ndc11_note/${ndc11}/${planning_type}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<notesInterface[]>(
            `fdp/get_ndc11_note/${ndc11}/${planning_type}`
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getGFCNotes, Err===', error);
        reject(error);
      }
    });
  },

  saveNDC11Note: (payload: {
    ndc11: string;
    note: string;
    planning_type: string;
  }): Promise<notesInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{
          msg: string;
          data: notesInterface[];
        }>(`fdp/save_ndc11_note`, payload);
        resolve(data.data);
      } catch (error) {
        console.log('in services > saveGFCNote, Err===', error);
        reject(error);
      }
    });
  },

  getFilteredData: (
    payload: filterPayloadInterface,
    signal: AbortController['signal'] | null = null
  ): Promise<bulkEditDataInterface[] | []> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<bulkEditDataInterface[] | []>(
            `fdp/get_unconstrained_forecast_bulk_edit_data`,
            payload,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await postRequest<bulkEditDataInterface[] | []>(
            `fdp/get_unconstrained_forecast_bulk_edit_data`,
            payload
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getFilteredData, Err===', error);
        reject(error);
      }
    });
  },

  getSupplierNameSuggestions: (): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<string[]>(
          `fdp/get_unconstrained_supplier_name_suggestions`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getSupplierNameSuggestions, Err===', error);
        reject(error);
      }
    });
  },

  getNDC11Suggestions: (
    query: string,
    signal: AbortSignal | undefined = undefined
  ): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<string[]>(
            `fdp/get_unconstrained_ndc_suggestions`,
            { query },
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          await postRequest<string[]>(
            `fdp/get_unconstrained_ndc_suggestions`,
            { query },
            undefined,
            { signal }
          );
        }
      } catch (error) {
        console.log('in services > getNDC11Suggestions, Err===', error);
        reject(error);
      }
    });
  },

  updateNote: (id: number, note: string): Promise<noteEditResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<noteEditResponse>(`fdp/update_ndc11note`, {
          id: id,
          note: note,
        });
        resolve(data);
      } catch (error) {
        console.log('in service > updateNote, Err===', error);
        reject(error);
      }
    });
  },

  deleteNote: (id: number): Promise<boolean> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<boolean>(`fdp/delete_ndc11note`, {
          id: id,
        });
        resolve(data);
      } catch (error) {
        console.log('in service > updateNote, Err===', error);
        reject(error);
      }
    });
  },

  downloadUploadTemplate: (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<Blob>(
          `fdp/unconstrained-forecast-upload-template/`,
          undefined,
          { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'unconstrained_forecast_template.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        resolve();
      } catch (error) {
        console.log('in service > downloadUploadTemplate, Err===', error);
        reject(error);
      }
    });
  },

  uploadForecastPreview: (formData: FormData): Promise<UploadForecastPreviewResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<UploadForecastPreviewResponse>(
          `fdp/unconstrained-forecast-upload-preview/`,
          formData,
          undefined,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        resolve(data);
      } catch (error) {
        console.log('in service > uploadForecastPreview, Err===', error);
        reject(error);
      }
    });
  },

  createForecastFromUpload: (payload: UploadForecastCreatePayload): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        await postRequest<{ message: string }>(
          `fdp/unconstrained-forecast-upload-create/`,
          payload
        );
        resolve();
      } catch (error) {
        console.log('in service > createForecastFromUpload, Err===', error);
        reject(error);
      }
    });
  },
};
